import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { Resource } from '@opentelemetry/resources';
import { SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { registerInstrumentations } from '@opentelemetry/instrumentation';

const exporterEndpoint =
  process.env.VITE_OTEL_EXPORTER_ENDPOINT ||
  (process.env.OTEL_EXPORTER_OTLP_ENDPOINT
    ? `${process.env.OTEL_EXPORTER_OTLP_ENDPOINT}/v1/traces`
    : 'http://91.203.134.93:4318/v1/traces');

const orgId = process.env.OTEL_ORG_ID || '5976fabc-aaf8-4995-9b89-8e41e3bc727a';
const appId = process.env.OTEL_APP_ID || 'talent_engine';
const env = process.env.OTEL_ENV || 'dev';
const serviceName = process.env.OTEL_SERVICE_NAME || 'talent-engine-frontend';
const serviceVersion = process.env.OTEL_SERVICE_VERSION || '2.14';

if (exporterEndpoint) {
  const exporter = new OTLPTraceExporter({
    url: exporterEndpoint,
  });

  const provider = new WebTracerProvider({
    resource: new Resource({
      [SEMRESATTRS_SERVICE_NAME]: serviceName,
      [SEMRESATTRS_SERVICE_VERSION]: serviceVersion,
      'deployment.environment': env,
      'service.name': serviceName,
      'service.namespace': appId,
      'service.version': serviceVersion,
      // Dual-reporting identity tags for Vigil v4
      'OTEL_SERVICE_NAME': serviceName,
      'OTEL_APP_ID': appId,
      'OTEL_ENV': env,
      'OTEL_ORG_ID': orgId,
      'vigil.org.id': orgId,
      'otel_org_id': orgId,
      'org_id': orgId,
      'app_id': appId,
      'otel_app_id': appId,
    }),
  });

  provider.addSpanProcessor(new BatchSpanProcessor(exporter));
  provider.register();

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [
          /localhost/,
          /127\.0\.0\.1/,
          /.*talentengine\.in/,
          /91\.203\.133\.211/,
          /164\.52\.203\.201/,
        ],
      }),
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [
          /localhost/,
          /127\.0\.0\.1/,
          /.*talentengine\.in/,
          /91\.203\.133\.211/,
          /164\.52\.203\.201/,
        ],
      }),
    ],
  });
}
